import { ValueOf } from '../utilities/types';

const transactionTableColumnSources = {
  SELECTED_ROW: 'selectedRow',
  TYPE_CONFIGURATION: 'typeConfiguration',
  CONFLICT_STATUS: 'conflictStatus',
  INCOMING_VOLUME: 'incoming.volume',
  INCOMING_MONTHLY_VOLUME: 'incoming.monthlyVolume',
  OUTGOING_VOLUME: 'outgoing.volume',
  OUTGOING_MONTHLY_VOLUME: 'outgoing.monthlyVolume',
  PROCESSING_VOLUME: 'processing.volume',
  PROCESSING_MONTHLY_VOLUME: 'processing.monthlyVolume',
  TOTAL_VOLUME: 'total.volume',
  TOTAL_MONTHLY_VOLUME: 'total.monthlyVolume',
  NET_VOLUME: 'netVolume',
  NET_MONTHLY_VOLUME: 'netMonthlyVolume',
  INCOMING_FREQUENCY: 'incoming.frequency',
  INCOMING_MONTHLY_FREQUENCY: 'incoming.monthlyFrequency',
  OUTGOING_FREQUENCY: 'outgoing.frequency',
  OUTGOING_MONTHLY_FREQUENCY: 'outgoing.monthlyFrequency',
  PROCESSING_FREQUENCY: 'processing.frequency',
  PROCESSING_MONTHLY_FREQUENCY: 'processing.monthlyFrequency',
  TOTAL_FREQUENCY: 'total.frequency',
  TOTAL_MONTHLY_FREQUENCY: 'total.monthlyFrequency',
  REMOVE_ROW: 'removeRow',
} as const;

export type TransactionTableColumnSource = ValueOf<typeof transactionTableColumnSources>;

export default transactionTableColumnSources;
